import { ThemeProvider } from 'antd-style';
import { useMemo, type ReactNode } from 'react';
import { buildThemeConfig, getSurfaceTokens } from './themeTokens';

export function ThemeScope({
  mode,
  isolated = false,
  children,
}: {
  mode: 'light' | 'dark';
  isolated?: boolean;
  children: ReactNode;
}) {
  const theme = useMemo(() => ({
    ...buildThemeConfig(mode),
    // ThemeProvider supplies the algorithm from appearance; apply it only once.
    algorithm: [],
    inherit: !isolated,
    cssVar: { key: isolated ? `qm-isolated-${mode}` : 'qm-theme' },
  }), [mode, isolated]);
  const surfaces = useMemo(() => getSurfaceTokens(mode), [mode]);

  return (
    <ThemeProvider appearance={mode} themeMode={mode} theme={theme} customToken={surfaces}>
      {isolated ? <div style={{ display: 'contents', colorScheme: mode }}>{children}</div> : children}
    </ThemeProvider>
  );
}
